import { message } from "antd";
import { apiBase } from "../utils/apiBase";
import { queryClient } from "../queries/queryClient";
import jwt_decode from "jwt-decode";
import { get } from "lodash";
import * as Sentry from "@sentry/react";

export const types = {
  USER_SET: "USER_SET",
};

export const setUser = (value) => ({
  type: types.USER_SET,
  value,
});

export const authenticateWithGoogle = (credential) => (dispatch) => {
  return apiBase
    .post("users/authenticate/google", { credential })
    .then((res) => {
      const { auth_token } = res.data;
      window.localStorage.setItem("authToken", auth_token);
      apiBase.defaults.headers.Authorization = `Bearer ${auth_token}`;
      return true;
    })
    .catch((err) => {
      message.error(
        get(err.response, "data.message", "Failed to sign in with Google.")
      );
      return false;
    });
};

export const getUser = () => (dispatch) => {
  const authToken = window.localStorage.getItem("authToken");
  if (!authToken) {
    return dispatch(setUser({}));
  }
  const tokenDecoded = jwt_decode(authToken);
  const userId = get(tokenDecoded, "user_id");
  return apiBase
    .get(`users/${userId}`)
    .then((res) => {
      dispatch(setUser(res.data));

      const userId = get(res, "data.id", null);
      const email = get(res, "data.email", null);
      const alias = get(res, "data.alias", null);

      Sentry.setUser({
        id: userId,
        email: email,
        username: alias,
      });
      Sentry.setTag("user_id", userId);
      Sentry.setTag("user_email", email);
      Sentry.setTag("user_name", alias);

      message.success("Logged In.");
      return res.data;
    })
    .catch((err) => {
      message.error(get(err.response, "data.detail", "Failed to fetch user."));
      window.localStorage.clear();
      Sentry.setUser(null);
      return null;
    });
};

export const logoutUser = () => (dispatch) => {
  // Call server to clear HttpOnly cookie
  apiBase
    .post("/users/logout")
    .catch((err) => {
      console.error("Logout error:", err);
    })
    .finally(() => {
      // Clear local storage and state regardless of server response
      window.localStorage.clear();
      apiBase.defaults.headers.Authorization = null;
      queryClient.clear();
      dispatch(setUser({}));
      Sentry.setUser(null);
      message.success("Logged Out.");
    });
};

export const initialState = {
  data: {},
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.USER_SET:
      return {
        data: action.value,
      };
    default:
      return state;
  }
}

const actions = {
  authenticateWithGoogle,
  getUser,
  logoutUser,
};

export default actions;
